<template>
  <div>
    <div class="flex flex-row items-center mb-6 transition-all">
      <div class="flex flex-row items-center">
        <div
          :class="[
            'flex h-6 w-6 hover:text-primary hover:border-primary rounded-full cursor-pointer items-center justify-center border transition-all transform flex items-center space-x-2',
            listsCollapsed
              ? 'rotate-180 text-black border-black ml-4'
              : 'border-truegray-300 text-truegray-300',
          ]"
          @click="toggleListCollapse"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            class="w-4 h-4"
          >
            <path
              fill-rule="evenodd"
              d="M15.79 14.77a.75.75 0 01-1.06.02l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 111.04 1.08L11.832 10l3.938 3.71a.75.75 0 01.02 1.06zm-6 0a.75.75 0 01-1.06.02l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 111.04 1.08L5.832 10l3.938 3.71a.75.75 0 01.02 1.06z"
              clip-rule="evenodd"
            />
          </svg>
        </div>
        <h6 v-if="listsCollapsed" class="ml-2 text-truegray-500">Show lists</h6>
      </div>

      <ul
        :class="[
          'flex flex-row flex-wrap items-center mb-0 list-none py-0',
          listsCollapsed ? 'hidden' : 'w-full',
        ]"
      >
        <li
          v-for="tab in tabs"
          :key="tab.id"
          :class="[{ hidden: tab.hidden() }]"
        >
          <button
            :class="[
              'tab px-5 py-3 flex items-center justify-center space-x-2 filter capitalize',
              {
                'border-0 grayscale opacity-50': !isTabActive(tab.id),
                'opacity-15 cursor-not-allowed': tab.disabled,
              },
            ]"
            :style="[isTabActive(tab.id) ? { color: activeTabColor } : {}]"
            :disabled="tab.disabled"
            @click="toggleTabs(tab.id)"
          >
            <img class="h-4 mr-2" :src="tab.img" alt="logo" />
            {{ tab.text }}
          </button>
        </li>
      </ul>

      <!-- queue alert -->
      <div v-if="showAlert" class="flex items-center justify-end w-full">
        <div
          class="flex items-center justify-start bg-green-400 text-white rounded px-3 py-2"
        >
          <p class="text-xs mr-2">
            Update queued! Refresh the list to see when it is processed.
          </p>

          <button
            class="flex justify-center items-center transform hover:rotate-90 transition-all duration-300 flex-shrink-0 ml-auto"
            @click="() => toggleAlert(false)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6 flex-shrink-0"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      </div>
      <!-- /queue alert -->
    </div>

    <div v-if="loadedLists">
      <div
        :class="listsCollapsed ? '' : 'gap-12 justify-between pl-2'"
        class="flex flex-row transition-all"
      >
        <template v-if="!showUpsell">
          <div
            id="cw-lists"
            :style="[{ maxHeight: '70vh', overflowY: 'scroll' }]"
            :class="
              listsCollapsed
                ? 'w-0 h-0 overflow-hidden'
                : 'w-full lg:w-6/12 2xl:w-5/12 max-w-xl pr-6 pb-4'
            "
            class="cw-newsletter-table-wrapper flex flex-col gap-2 transition-all"
          >
            <div
              v-for="list in filteredLists"
              :key="list.id"
              class="flex flex-col w-full mb-2 last:mb-0"
              :class="{ hidden: listsCollapsed }"
            >
              <button
                class="flex items-center bg-white p-4 py-2 w-full text-left rounded-md border gap-4"
                :class="[
                  'border-2',
                  isListActive(list.id)
                    ? 'border-primary py-4'
                    : 'border-gray-100',
                ]"
                @click="setActiveList(list.id)"
              >
                <!-- :style="isListActive(list.id) ? { borderColor: activeTabColor } : {}" -->
                <!--
                  <div class="mr-4 self-center hidden lg:flex">
                  <button :class="isListActive(list.id) ? 'visible': 'invisible'">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-8 h-8 text-black">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                  </svg> 
                -->
                <!--
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6 text-primary">
                  <path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clip-rule="evenodd" />
                  </svg> 
                -->
                <!--
                  </button>
                  </div> 
                -->
                <div class="flex flex-row justify-start align-start w-8/12">
                  <div class="flex flex-col mr-4">
                    <h5 class="font-primary flex items-center">
                      <span
                        v-if="isListActive(list.id)"
                        class="bg-primary w-2 h-2 rounded-full overflow-hidden mr-2"
                      />
                      <!-- :style="{ backgroundColor: activeTabColor }"  -->
                      {{ list.name }}
                    </h5>
                    <!-- <h6 v-if="list.address" class="text-gray-600">{{ list.address }}</h6> -->
                    <h6 v-if="list.updatedAt" class="text-gray-400">
                      Last updated: {{ getDateFormatted(list.updatedAt) }}
                    </h6>
                  </div>
                </div>
                <div
                  class="self-center ml-auto flex flex-col space-y-2 justify-center items-center my-2"
                >
                  <InfoChip
                    :text="getListChipConfig(list).text"
                    :color="getListChipConfig(list).color"
                  />
                  <div
                    v-if="!activeTabId"
                    class="flex flex-row justify-center items-center space-x-2"
                  >
                    <div
                      v-for="(opt, index) in listsActions"
                      :key="index"
                      :class="{
                        hidden:
                          isCateRegionalAdmin ||
                          opt.hideAction(
                            list.uneditable,
                            list.undeletable,
                            list.canExportList,
                          ),
                      }"
                    >
                      <button
                        class="text-truegray-300 hover:text-primary"
                        @click="(e) => dispatchActionList(opt.action, list, e)"
                      >
                        <span v-html="opt.icon" />
                      </button>
                    </div>
                  </div>
                </div>
              </button>
            </div>
          </div>
          <div
            id="cw-list-subscribers"
            class="cw-newsletter-table-wrapper flex-grow pb-4 transition-all"
          >
            <div
              v-if="subscribersTitle"
              class="flex justify-between align-center mb-6"
            >
              <div class="flex items-center mr-4">
                <h5 class="font-primary text-black self-center mr-3">
                  {{ subscribersTitle }}
                </h5>
                <button
                  title="Refresh list data"
                  class="transform hover:rotate-180 transition-all duration-300 h-full self-center mr-3"
                  @click="initList"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-5 h-5 hover:text-primary"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
                    />
                  </svg>
                </button>
              </div>
              <!-- :style="{ color: activeTabColor }" -->
              <div
                :class="['flex flex-shrink-0 items-center justify-self-end']"
              >
                <t-dropdown
                  v-if="canBulkAction"
                  :class="[!!selectedSubscribers.length ? 'mr-4' : 'hidden']"
                >
                  <template
                    #trigger="{
                      mousedownHandler,
                      focusHandler,
                      blurHandler,
                      keydownHandler,
                    }"
                  >
                    <button
                      class="flex items-center justify-between self-center text-white block px-4 py-2 transition duration-100 ease-in-out border border-transparent rounded-md shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed btn btn-primary btn-inverted h-10 mb-0"
                      @mousedown="mousedownHandler"
                      @focus="focusHandler"
                      @blur="blurHandler"
                      @keydown="keydownHandler"
                    >
                      <span>{{ subscribersBulkActionsText }}</span>
                      <div>
                        <svg
                          viewBox="0 0 20 20"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          class="fill-current h-3 w-3 ml-2"
                        >
                          <g
                            id="Page-13"
                            stroke="none"
                            stroke-width="1"
                            fill="currentColor"
                            fill-rule="evenodd"
                          >
                            <g id="icon-shape">
                              <path d="M19 9l-7 7-7-7"></path>
                            </g>
                          </g>
                        </svg>
                      </div>
                    </button>
                  </template>
                  <template #default="{ blurHandler }">
                    <div
                      v-for="(opt, index) in subscribersBulkActions"
                      :key="index"
                    >
                      <button
                        class="text-left block w-full px-4 py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                        role="menuitem"
                        @blur="blurHandler"
                        @click="() => opt.callback()"
                      >
                        {{ opt.title }}
                      </button>
                    </div>
                  </template>
                </t-dropdown>
                <button
                  v-if="canAddSubscribers"
                  type="button"
                  :class="['btn btn-primary rounded-md h-10 px-6 mb-0']"
                  @click="addSubscribersToList"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-4 h-4"
                    :class="{ 'mr-2': !selectedSubscribers.length }"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M12 4.5v15m7.5-7.5h-15"
                    />
                  </svg>
                  <span v-if="!selectedSubscribers.length">Subscribers</span>
                </button>
              </div>
            </div>
            <div class="border rounded-md">
              <div :class="['flex items-center border-b p-4 w-full']">
                <!--
                  <div 
                  v-for="(item, index) in subscribersHeadersShifted" 
                  :key="index"
                  :class="[item.class, {'hidden' : item.value === 'createdAt'}]"
                  >
                  <div v-if="item.value === 'selected'">
                  <t-checkbox
                  v-model="selectAllSubscribers"
                  :disabled="!subscribersActive.length"
                  @change="setSelectAllSubscribers"
                  />
                  </div>
                  <div v-else class="flex flex-row align-center">
                  <div class="mr-2 font-primary">
                  {{ item.text }}
                  </div>
                  <div v-if="item.sort">
                  <button class="h-full my-auto text-black hover:text-primary" @click="() => setSubscribersColumnSortBy(item.value)">
                  <svg :class="subscribersSortBy === item.value && subscribersSortDesc ? 'rotate-180' : ''" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-3 h-3 transform transition-all">
                  <path fill-rule="evenodd" d="M10 2a.75.75 0 01.75.75v12.59l1.95-2.1a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 111.1-1.02l1.95 2.1V2.75A.75.75 0 0110 2z" clip-rule="evenodd" />
                  </svg>
                  </button>
                  </div>
                  </div>
                  </div> 
                -->
                <div class="w-5/12 flex items-center">
                  <div
                    v-if="showHeader(0)"
                    :class="[subscribersHeaders[0].class]"
                  >
                    <div v-if="subscribersHeaders[0].value === 'selected'">
                      <t-checkbox
                        v-model="selectAllSubscribers"
                        :disabled="!subscribersActive.length"
                        @change="setSelectAllSubscribers"
                      />
                    </div>
                  </div>

                  <div
                    v-if="showHeader(1)"
                    :class="[subscribersHeaders[1].class]"
                  >
                    <div class="flex flex-row align-center">
                      <div class="mr-2 font-primary">
                        {{ subscribersHeaders[1].text }}
                      </div>
                      <div v-if="subscribersHeaders[1].sort">
                        <button
                          class="h-full my-auto text-black hover:text-primary"
                          @click="
                            () =>
                              setSubscribersColumnSortBy(
                                subscribersHeaders[1].value,
                              )
                          "
                        >
                          <svg
                            :class="
                              subscribersSortBy ===
                                subscribersHeaders[1].value &&
                              subscribersSortDesc
                                ? 'rotate-180'
                                : ''
                            "
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            class="w-3 h-3 transform transition-all"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M10 2a.75.75 0 01.75.75v12.59l1.95-2.1a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 111.1-1.02l1.95 2.1V2.75A.75.75 0 0110 2z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="w-7/12 flex items-center justify-end space-x-6">
                  <div
                    v-if="showHeader(4)"
                    class="flex items-center justify-center flex-shrink-0"
                    :class="[listsCollapsed ? 'w-32' : 'w-1/2']"
                  >
                    <div class="flex flex-row align-center">
                      <div class="mr-2 font-primary">
                        {{ subscribersHeaders[4].text }}
                      </div>
                      <div v-if="subscribersHeaders[4].sort">
                        <button
                          class="h-full my-auto text-black hover:text-primary"
                          @click="
                            () =>
                              setSubscribersColumnSortBy(
                                subscribersHeaders[4].value,
                              )
                          "
                        >
                          <svg
                            :class="
                              subscribersSortBy ===
                                subscribersHeaders[4].value &&
                              subscribersSortDesc
                                ? 'rotate-180'
                                : ''
                            "
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            class="w-3 h-3 transform transition-all"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M10 2a.75.75 0 01.75.75v12.59l1.95-2.1a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 111.1-1.02l1.95 2.1V2.75A.75.75 0 0110 2z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="showHeader(5)"
                    class="flex flex-shrink-0 items-center justify-end text-right w-14"
                  >
                    <div class="flex flex-row align-center">
                      <div class="mr-2 font-primary">
                        {{ subscribersHeaders[5].text }}
                      </div>
                      <div v-if="subscribersHeaders[5].sort">
                        <button
                          class="h-full my-auto text-black hover:text-primary"
                          @click="
                            () =>
                              setSubscribersColumnSortBy(
                                subscribersHeaders[5].value,
                              )
                          "
                        >
                          <svg
                            :class="
                              subscribersSortBy ===
                                subscribersHeaders[5].value &&
                              subscribersSortDesc
                                ? 'rotate-180'
                                : ''
                            "
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            class="w-3 h-3 transform transition-all"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M10 2a.75.75 0 01.75.75v12.59l1.95-2.1a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 111.1-1.02l1.95 2.1V2.75A.75.75 0 0110 2z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <DynamicScroller
                v-if="
                  !!subscribersActive.length &&
                  loadedList &&
                  !isCateRegionalAdmin
                "
                :items="subscribersActive"
                :min-item-size="54"
                class="max-h-80"
              >
                <template #default="{ item, index, active }">
                  <DynamicScrollerItem
                    :item="item"
                    :active="active"
                    :size-dependencies="[item.email]"
                    :data-index="index"
                  >
                    <div
                      :class="[
                        'flex items-center gap-4 bg-white p-4 py-2 w-full text-left rounded-md z-0 relative',
                        { 'bg-gray-50': item.selected },
                      ]"
                    >
                      <div
                        :class="[
                          'flex items-center',
                          isHail ? 'w-8/12' : 'w-5/12',
                        ]"
                      >
                        <div v-if="!isHail" class="w-6 flex-shrink-0">
                          <t-checkbox
                            v-model="item.selected"
                            @change="() => toggleSelectSubscriber(item.id)"
                          />
                        </div>
                        <div
                          :class="listsCollapsed ? 'w-full' : 'w-10/12'"
                          class="truncate overflow-ellipsis text-xs"
                        >
                          {{ item.email }}
                        </div>
                      </div>

                      <div
                        :class="[
                          'flex items-center justify-end space-x-6',
                          isHail ? 'w-4/12' : 'w-7/12',
                        ]"
                      >
                        <div
                          :class="[
                            listsCollapsed ? 'w-32' : 'w-1/2',
                            isHail ? 'justify-end' : 'justify-center',
                          ]"
                          class="flex flex-shrink-0 items-center capitalize text-xs"
                        >
                          <InfoChip
                            :text="
                              getSubscriberStatusChipConfig(item.status).text
                            "
                            :color="
                              getSubscriberStatusChipConfig(item.status).color
                            "
                          />
                        </div>
                        <div
                          v-if="!isHail"
                          :class="listsCollapsed ? 'w-auto' : ''"
                          class="flex flex-shrink-0 items-center justify-end text-right"
                        >
                          <button
                            title="Stats"
                            class="mr-2"
                            @click="showSubscriberStats(item)"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                              class="w-4 h-4 text-truegray-300 hover:text-primary"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z"
                                clip-rule="evenodd"
                              />
                            </svg>

                            <!--
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5">
                              <path d="M15.5 2A1.5 1.5 0 0014 3.5v13a1.5 1.5 0 001.5 1.5h1a1.5 1.5 0 001.5-1.5v-13A1.5 1.5 0 0016.5 2h-1zM9.5 6A1.5 1.5 0 008 7.5v9A1.5 1.5 0 009.5 18h1a1.5 1.5 0 001.5-1.5v-9A1.5 1.5 0 0010.5 6h-1zM3.5 10A1.5 1.5 0 002 11.5v5A1.5 1.5 0 003.5 18h1A1.5 1.5 0 006 16.5v-5A1.5 1.5 0 004.5 10h-1z" />
                              </svg> 
                            -->
                          </button>
                          <button
                            title="Edit"
                            class="mr-2 text-truegray-300 hover:text-primary"
                            @click="updateSubscriber(item)"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                              class="w-4 h-4 text-truegray-300 hover:text-primary"
                            >
                              <path
                                d="M2.695 14.763l-1.262 3.154a.5.5 0 00.65.65l3.155-1.262a4 4 0 001.343-.885L17.5 5.5a2.121 2.121 0 00-3-3L3.58 13.42a4 4 0 00-.885 1.343z"
                              />
                            </svg>
                          </button>
                          <button
                            @click="
                              () => toggleShowSubscriberBulkActions(item.id)
                            "
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                              class="w-4 h-4 text-truegray-300 hover:text-primary"
                            >
                              <path
                                d="M3 10a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM8.5 10a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM15.5 8.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
                              />
                            </svg>
                          </button>
                          <div
                            :class="[
                              'absolute right-0 top-0 z-10 h-full transition-all duration-150 ease-in-out',
                              item.showBulkActions
                                ? 'px-4 flex flex-row items-center bg-white border-l border-b border-t rounded-l-md w-auto'
                                : 'w-0',
                            ]"
                          >
                            <button
                              title="Stats"
                              :class="[
                                'mr-3',
                                item.showBulkActions ? 'visible' : 'hidden',
                              ]"
                              @click="showSubscriberStats(item)"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                class="w-4 h-4 text-truegray-300 hover:text-primary"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z"
                                  clip-rule="evenodd"
                                />
                              </svg>
                            </button>
                            <button
                              title="Edit"
                              :class="[
                                'mr-3',
                                item.showBulkActions ? 'visible' : 'hidden',
                              ]"
                              @click="updateSubscriber(item)"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                class="w-4 h-4 text-truegray-300 hover:text-primary"
                              >
                                <path
                                  d="M2.695 14.763l-1.262 3.154a.5.5 0 00.65.65l3.155-1.262a4 4 0 001.343-.885L17.5 5.5a2.121 2.121 0 00-3-3L3.58 13.42a4 4 0 00-.885 1.343z"
                                />
                              </svg>
                            </button>
                            <div
                              v-for="(
                                opt, actionIndex
                              ) in subscribersBulkActions"
                              :key="actionIndex"
                              class="flex"
                            >
                              <button
                                :title="opt.title"
                                :class="[
                                  'mr-3',
                                  item.showBulkActions ? 'visible' : 'hidden',
                                ]"
                                @click="() => opt.callback(item)"
                              >
                                <span v-html="opt.icon" />
                              </button>
                            </div>
                            <button
                              :class="[
                                item.showBulkActions ? 'visible' : 'hidden',
                              ]"
                              @click="
                                () =>
                                  toggleShowSubscriberBulkActions(
                                    item.id,
                                    false,
                                  )
                              "
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                class="w-5 h-5 text-truegray-300 hover:text-primary"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                                  clip-rule="evenodd"
                                />
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </DynamicScrollerItem>
                </template>
              </DynamicScroller>
              <div v-else-if="!loadedList" class="w-full h-14">
                <lottie :options="loadingAnimationOptions" />
              </div>
              <div v-else-if="isCateRegionalAdmin" class="p-4">
                <t-alert show :dismissible="false" variant="error">
                  <span>You do not have permission to view subscribers.</span>
                </t-alert>
              </div>
              <div v-else class="p-4">
                <t-alert show :dismissible="false" variant="error">
                  <span>No subscribers.</span>
                  <span v-if="canAddSubscribers">Add some!</span>
                </t-alert>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div
            class="flex flex-col space-y-2 w-full lg:w-1/2 text-truegray-500"
          >
            <p>
              <a
                :style="{ color: 'rgb(160, 212, 104)' }"
                target="_blank"
                href="https://get.hail.to/"
                >Hail</a
              >
              is a popular communications tool used by over 600 schools all over
              New Zealand.
            </p>
            <p>
              Hail is a design-free service that helps schools communicate,
              create websites, newsletters, notices, articles, alerts and so
              much more!
            </p>
            <p>
              By syncing CareerWise with Hail, you can share mailing lists
              across both platforms, as well as unlock access to Kamar and other
              student management systems. With the student management system
              upgrade (SMS), you will be able to send your newsletters to all
              the different groups in your SMS, which will be updated
              automatically!
            </p>
            <p class="italic">
              Note: Only Kamar & Pcschool available currently. More SMS's are
              coming soon.
            </p>
            <div>
              <button
                class="btn btn-primary mt-8 w-60"
                @click="handleUpgrade()"
              >
                Find out more
              </button>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div v-else class="w-full h-14">
      <lottie :options="loadingAnimationOptions" />
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, watch, ref, onMounted } from 'vue'
import { useStore } from '../../../../../js/store/index.js'
import { EventBus } from '../../../../../js/plugins/event-bus.js'
import * as loadingAnimation from '../../../../../shared/components/loading-dark.json'
import {
  pluraliseString,
  getDateFormatted,
} from '../../../../../js/util/helper.js'
import InfoChip from '../../../../../shared/components/InfoChip.vue'

export default defineComponent({
  name: 'TabLists',

  components: {
    InfoChip,
  },

  props: {
    activeListIdInitial: {
      type: Number,
      default: null,
    },

    subscribersHeaders: {
      type: Array,
      required: true,
    },

    getSubscriberStatusChipConfig: {
      type: Function,
      required: true,
    },

    searchFilter: {
      type: String,
      required: true,
    },

    includeSearchFilter: {
      type: Boolean,
      required: true,
    },
  },

  emits: ['reset-active-list'],

  setup(props, { emit }) {
    const store = useStore()

    // setup
    const loadingAnimationOptions = { animationData: loadingAnimation.default }
    const isCateRegionalAdmin = computed(() => {
      return store.getters['shared/isCateRegionalAdmin']
    })
    const loadedLists = ref(true)
    const loadedList = ref(true)
    const listsCollapsed = ref(false)

    // tabs
    const tabs = computed(() => {
      const optionsMap = {
        careerwise: {
          hidden: () => listsCollapsed.value,
        },
        hail: {
          hidden: () => listsCollapsed.value,
        },
        sms: {
          hidden: () =>
            !store.getters['careerwise/hasHail'] ||
            !store.getters['careerwise/hasSMS'] ||
            listsCollapsed.value,
        },
      }

      return store.getters['careerwise/getMailTypesConfig'](optionsMap)
    })

    const activeTabId = ref(null)

    const activeTabColor = computed(() => {
      return (
        tabs.value?.find((tab) => tab.id === activeTabId.value)?.color ||
        'black'
      )
    })
    const activeTabText = computed(() => {
      return (
        tabs.value?.find((tab) => tab.id === activeTabId.value)?.text || null
      )
    })

    const isHail = computed(() => activeTabId.value > 0)
    const showUpsell = computed(
      () => isHail.value && !store.getters['careerwise/hasHail'],
    )
    const isTabActive = (tabId) => {
      return activeTabId.value === tabId
    }

    const handleUpgrade = () => {
      EventBus.$emit('showModal', {
        action: 'cw-registration',
        data: { reason: 5 },
      })
    }

    const toggleTabs = (tabId) => {
      activeListId.value = null
      activeTabId.value = tabId
    }

    const showModal = (type, data = {}) => {
      EventBus.$emit('showModal', {
        action: type,
        data,
      })
    }

    watch(activeTabId, async () => {
      loadedLists.value = false
      // @todo emits
      emit('reset-active-list')

      if (!activeTabId.value) {
        // only init CW lists (activeTabId: 0)
        // re-init Hail only on refresh/view change
        await store.dispatch('careerwise/dispatchGetMailLists')
      }

      setLists()
      loadedLists.value = true
    })

    // filtering
    const searchFilterTrimmed = computed(() =>
      props.searchFilter?.toLowerCase()?.trim(),
    )

    watch(
      () => props.searchFilter,
      () => {
        if (filteredLists.value.length) {
          setActiveList(filteredLists.value[0].id)
        }
      },
    )

    // lists
    const lists = ref([])
    const mailLists = computed(() => {
      return store.getters['careerwise/getMailLists']
    })
    const mailListsHail = computed(() => {
      return store.getters['careerwise/getMailListsHail']('hail')
    })
    const mailListsKamar = computed(() => {
      return store.getters['careerwise/getMailListsHail']('kamar')
    })
    const mailListsPcschool = computed(() => {
      return store.getters['careerwise/getMailListsHail']('pcschool')
    })

    const getListsBySMSID = (id) => {
      return store.getters['careerwise/getListsBySMSID'](id)
    }

    const filteredLists = computed(() => {
      if (searchFilterTrimmed.value) {
        return lists.value.filter(filterLists)
      }
      return lists.value
    })
    const activeListId = ref(null)
    const activeList = computed(() => {
      return (
        filteredLists.value.find((list) => list.id === activeListId.value) ||
        null
      )
    })
    const listsActions = [
      // {
      //   name: 'add',
      //   title: 'Add to list',
      //   icon:
      //     `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
      //       <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
      //     </svg>`,
      //   action: 'updateLists'
      // },
      {
        name: 'edit',
        title: 'Edit list',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-4 h-4">
            <path d="M2.695 14.763l-1.262 3.154a.5.5 0 00.65.65l3.155-1.262a4 4 0 001.343-.885L17.5 5.5a2.121 2.121 0 00-3-3L3.58 13.42a4 4 0 00-.885 1.343z" />
          </svg> `,

        action: 'updateList',
        hideAction: (uneditable) => !!uneditable,
      },
      {
        name: 'delete',
        title: 'Delete',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-4 h-4">
          <path fill-rule="evenodd" d="M8.75 1A2.75 2.75 0 006 3.75v.443c-.795.077-1.584.176-2.365.298a.75.75 0 10.23 1.482l.149-.022.841 10.518A2.75 2.75 0 007.596 19h4.807a2.75 2.75 0 002.742-2.53l.841-10.52.149.023a.75.75 0 00.23-1.482A41.03 41.03 0 0014 4.193V3.75A2.75 2.75 0 0011.25 1h-2.5zM10 4c.84 0 1.673.025 2.5.075V3.75c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v.325C8.327 4.025 9.16 4 10 4zM8.58 7.72a.75.75 0 00-1.5.06l.3 7.5a.75.75 0 101.5-.06l-.3-7.5zm4.34.06a.75.75 0 10-1.5-.06l-.3 7.5a.75.75 0 101.5.06l.3-7.5z" clip-rule="evenodd" />
        </svg>`,

        action: 'deleteList',
        hideAction: (_uneditable, undeletable) => !!undeletable,
      },
      {
        name: 'export',
        title: 'Export',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-4 h-4">
          <path d="M10.75 2.75a.75.75 0 00-1.5 0v8.614L6.295 8.235a.75.75 0 10-1.09 1.03l4.25 4.5a.75.75 0 001.09 0l4.25-4.5a.75.75 0 00-1.09-1.03l-2.955 3.129V2.75z" />
          <path d="M3.5 12.75a.75.75 0 00-1.5 0v2.5A2.75 2.75 0 004.75 18h10.5A2.75 2.75 0 0018 15.25v-2.5a.75.75 0 00-1.5 0v2.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25v-2.5z" />
        </svg>`,

        action: 'exportList',
        hideAction: (_uneditable, _undeletable, canExportList) =>
          !canExportList,
      },
    ]

    const getListChipConfig = (list) => {
      const count = list.subscribers?.length
      const text = count
        ? `${count} ${pluraliseString('subscriber', count)}`
        : 'No subscribers'

      // subscribed, Hail, default
      let color = 'gray'
      // bounced, unsubscribed
      if (list.id < 0) {
        color = 'red'
      }

      return {
        text,
        color,
      }
    }

    const canAddSubscribers = computed(() => {
      if (isCateRegionalAdmin.value) {
        return false
      }
      return activeList.value?.canAddSubscribers || false
    })

    const isListActive = (listId) => {
      return activeListId.value === listId
    }

    const setActiveList = (listId) => {
      activeListId.value = listId
    }

    const toggleListCollapse = () => {
      listsCollapsed.value = !listsCollapsed.value
    }

    const setLists = (listId) => {
      const setDefaultList = () => {
        // select default (first) list
        setActiveList(lists.value[0]?.id || null)
      }

      initSubscribers()

      // Hail
      if (activeTabId.value) {
        // // Kamar
        // if (activeTabId.value === 2) {
        //   lists.value = mailListsKamar.value
        // } else if (activeTabId.value === 3) {
        //     lists.value = mailListsPcschool.value
        //   }

        // // Hail
        // else {
        //   lists.value = mailListsHail.value
        // }
        // Hail
        if (activeTabId.value === 1) {
          lists.value = mailListsHail.value
        }
        // Find which sms we are dealing with
        else {
          lists.value = getListsBySMSID(activeTabId.value)
        }

        setDefaultList()

        // Careerwise
      } else {
        lists.value = mailLists.value
        if (props.activeListIdInitial) {
          // routed to list from Subscribers view
          setActiveList(props.activeListIdInitial)
        } else if (listId) {
          setActiveList(listId)
        } else {
          setDefaultList()
        }
      }
    }

    const filterLists = (list) => {
      const verified =
        // list.name?.toLowerCase().indexOf(searchFilterTrimmed.value) > -1 ||
        // list.address?.toLowerCase().indexOf(searchFilterTrimmed.value?.toLowerCase()) > -1 ||
        !!list.subscribers?.find((subscriber) => filterSubscribers(subscriber))

      return verified
    }

    const actionsLists = {
      updateList: (list) => {
        const data = {
          list,
          title: `Update "${list.name}"`,
          action: 'update',
        }

        showModal('cw-update-list', data)
      },

      deleteList: (list) => {
        const data = {
          list,
          title: `Delete "${list.name}"`,
          subtitle: `Are you sure you want to delete this list?
            Deleting the list will not delete the subscribers,
            but they will no longer be grouped under "${list.name}".`,

          action: 'delete',
        }

        showModal('cw-delete-list', data)
      },

      exportList: async (list) => {
        const payload = {
          mail_list_ids: [list.id],
        }

        await store.dispatch(
          'careerwise/dispatchExportMailListFollowers',
          payload,
        )
      },
    }

    const dispatchActionList = async (action, list, event = null) => {
      if (event) {
        event.stopPropagation()
      }
      if (list) {
        return await actionsLists[action](list)
      }
      return await actionsLists[action]()
    }

    // queue alert
    const showAlert = ref(false)
    const toggleAlert = (value = !showAlert.value) => {
      showAlert.value = value
    }

    const initList = async (closeAlert = true) => {
      if (!isHail.value) {
        loadedList.value = false
        await store.dispatch('careerwise/dispatchGetFollowers')
        // also refresh Bounced and Unlisted if necessary
        if (activeListId.value < 0) {
          await store.dispatch('careerwise/dispatchGetUnsubscribedFollowers')
        }
        setLists(activeListId.value)
        loadedList.value = true
      }

      if (closeAlert) {
        toggleAlert(false)
      }

      initSubscribers()
    }

    watch(activeListId, () => initList())

    // subscribers
    const subscribersActive = ref([])
    const subscribersRows = computed(() => {
      return activeList.value?.subscribers?.filter(filterSubscribers) || []
    })
    const selectedSubscribers = computed(() => {
      return subscribersActive.value.filter(
        (subscriber) => !!subscriber.selected,
      )
    })
    const selectAllSubscribers = ref(false)
    const subscribersSortBy = ref(null)
    const subscribersSortDesc = ref(false)
    const subscribersTitle = computed(() => activeList.value?.name || '')

    // const subscribersHeadersShifted = computed(() => {
    //   const hail = isHail.value
    //   const headers = JSON.parse(JSON.stringify(props.subscribersHeaders))
    //     .filter(header => {
    //       // lists are redundant
    //       const isLists = header.value === 'lists'
    //       // Hail subscribers cannot be actioned
    //       if (hail) return !isLists && header.value !== 'createdAt' && header.value !== 'selected' && header.value !== 'actions'
    //       return !isLists
    //     })

    //   return headers
    // })

    const showHeader = (headerIndex) => {
      return !isHail.value || props.subscribersHeaders[headerIndex].isHail
    }

    const subscribersBulkActions = computed(() => {
      if (isHail.value) {
        return []
      }

      const actions = [
        {
          name: 'remove',
          title: 'Remove',
          icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-4 h-4 text-truegray-300 hover:text-primary">
              <path d="M11 5a3 3 0 11-6 0 3 3 0 016 0zM2.046 15.253c-.058.468.172.92.57 1.175A9.953 9.953 0 008 18c1.982 0 3.83-.578 5.384-1.573.398-.254.628-.707.57-1.175a6.001 6.001 0 00-11.908 0zM12.75 7.75a.75.75 0 000 1.5h5.5a.75.75 0 000-1.5h-5.5z" />
            </svg>`,
          callback: (subscriber) => {
            const subs = subscriber ? [subscriber] : selectedSubscribers.value
            const key = pluraliseString('subscriber', subs.length)
            let data = {
              title: `Remove ${key} from "${activeList.value?.name}"`,
              subtitle: `Are you sure you want to remove the following ${key} from list "${activeList.value?.name}"?
                This will not delete the ${key} - they may still be grouped under other lists.
              `,
              subscribers: subs,
              listId: activeListId.value,
              action: 'remove',
            }

            showModal('cw-delete-subscriber', data)
          },
          canAction: activeList.value?.canRemoveSubscribers,
        },

        {
          name: 'delete',
          title: 'Delete',
          icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-4 h-4 text-truegray-300 hover:text-primary">
              <path fill-rule="evenodd" d="M8.75 1A2.75 2.75 0 006 3.75v.443c-.795.077-1.584.176-2.365.298a.75.75 0 10.23 1.482l.149-.022.841 10.518A2.75 2.75 0 007.596 19h4.807a2.75 2.75 0 002.742-2.53l.841-10.52.149.023a.75.75 0 00.23-1.482A41.03 41.03 0 0014 4.193V3.75A2.75 2.75 0 0011.25 1h-2.5zM10 4c.84 0 1.673.025 2.5.075V3.75c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v.325C8.327 4.025 9.16 4 10 4zM8.58 7.72a.75.75 0 00-1.5.06l.3 7.5a.75.75 0 101.5-.06l-.3-7.5zm4.34.06a.75.75 0 10-1.5-.06l-.3 7.5a.75.75 0 101.5.06l.3-7.5z" clip-rule="evenodd" />
            </svg>`,
          callback: (subscriber) => {
            const subs = subscriber ? [subscriber] : selectedSubscribers.value
            let data = {
              title: pluraliseString('Delete subscriber', subs.length),
              subtitle: `Are you sure you want to delete the following ${pluraliseString(
                'subscriber',
                subs.length,
              )}?`,
              subscribers: subs,
              listId: activeListId.value,
              action: 'delete',
            }

            showModal('cw-delete-subscriber', data)
          },
          canAction: activeList.value?.canDeleteSubscribers,
        },
      ]

      return actions.filter((a) => a.canAction)
    })

    const canBulkAction = computed(() => {
      return !!subscribersBulkActions.value.length
    })

    const subscribersBulkActionsText = computed(() => {
      const count = selectedSubscribers.value.length
      const allSelected = count === activeList.value?.subscribers?.length
      if (allSelected) {
        return `All selected (${count})`
      }

      return `${count} selected`
    })

    const filterSubscribers = (subscriber) => {
      const searchIndex = subscriber.email
        ?.toLowerCase()
        ?.indexOf(searchFilterTrimmed.value)
      const verified = props.searchFilter
        ? props.includeSearchFilter
          ? searchIndex > -1
          : searchIndex < 0
        : true

      return verified
    }

    const toggleShowSubscriberBulkActions = (id, val = true) => {
      // reset all other bulk actions modals
      subscribersActive.value = [
        ...subscribersActive.value.map((sub) => {
          return { ...sub, showBulkActions: false }
        }),
      ]
      const subscriber = subscribersActive.value.find(
        (subscriber) => subscriber.id === id,
      )
      if (subscriber) {
        subscriber.showBulkActions = val
        subscribersActive.value = [...subscribersActive.value] // trigger reactivity!
      }
    }

    const toggleSelectSubscriber = (subscriber) => {
      if (!subscriber.selected) {
        selectAllSubscribers.value = false
      }
    }

    const setSelectAllSubscribers = (val = !selectAllSubscribers.value) => {
      selectAllSubscribers.value = val

      const subscribers = subscribersActive.value.map((subscriber) => {
        return {
          ...subscriber,
          selected: val,
        }
      })

      subscribersActive.value = subscribers
    }

    const sortSubscribersColumn = () => {
      const sortBy = subscribersSortBy.value
      const sortDesc = subscribersSortDesc.value ? 1 : -1

      if (!sortBy) {
        return
      }

      const subscribers = [...subscribersActive.value].sort((a, b) => {
        const A = a[sortBy],
          B = b[sortBy]

        if (typeof A === 'number') {
          return sortDesc * (B - A)
        }

        return sortDesc * A.localeCompare(B)
      })

      subscribersActive.value = subscribers
    }

    const setSubscribersColumnSortBy = (sortBy) => {
      if (subscribersSortBy.value !== sortBy) {
        // sort by different column;
        // reset sortDesc
        subscribersSortBy.value = sortBy
        subscribersSortDesc.value = true
      } else {
        // sort by same column;
        // just toggle sortDesc
        subscribersSortDesc.value = !subscribersSortDesc.value
      }

      sortSubscribersColumn()
    }

    const showSubscriberStats = (subscriber) => {
      const data = {
        subscriber,
      }

      showModal('cw-stats-subscriber', data)
    }

    const addSubscribersToList = () => {
      const data = {
        list: activeList.value,
        title: `Add subscribers to "${activeList.value?.name}"`,
        action: 'add',
      }

      showModal('cw-update-subscriber', data)
    }

    const updateSubscriber = (subscriber) => {
      const data = {
        title: 'Update subscriber',
        subscriber,
        action: 'update',
        list: activeList.value,
      }

      showModal('cw-update-subscriber', data)
    }

    const initSubscribers = () => {
      setSelectAllSubscribers(false)
    }

    watch(subscribersRows, () => {
      // create a copy so we don't mutate the original subscriber data;
      // concerned about deep object modification/reactivity/state tracking;
      // e.g., when selecting a new list, subscriber checkboxes should be reset
      const copy = JSON.parse(JSON.stringify(subscribersRows.value))
      subscribersActive.value = copy
    })

    watch(selectedSubscribers, () => {
      const val = subscribersActive.value?.length
        ? selectedSubscribers.value.length === subscribersActive.value.length
        : false
      selectAllSubscribers.value = val
    })

    onMounted(() => {
      activeTabId.value = 0

      EventBus.$on('setActiveListId', (value) => {
        setActiveList(value)
      })

      EventBus.$on('triggerListAlert', (value = true) => {
        toggleAlert(value)
      })

      EventBus.$on('setLists', () => {
        setLists()
      })
    })

    return {
      getDateFormatted,
      loadingAnimationOptions,
      isCateRegionalAdmin,
      loadedLists,
      loadedList,
      listsCollapsed,

      tabs,
      activeTabId,
      activeTabColor,
      activeTabText,
      isHail,
      showUpsell,
      handleUpgrade,
      isTabActive,
      toggleTabs,
      showModal,
      searchFilterTrimmed,

      lists,
      filteredLists,
      activeListId,
      activeList,
      listsActions,
      getListChipConfig,
      canAddSubscribers,
      isListActive,
      setActiveList,
      toggleListCollapse,
      dispatchActionList,
      initList,
      showAlert,
      toggleAlert,

      mailListsHail,
      mailListsKamar,
      mailListsPcschool,
      getListsBySMSID,

      subscribersActive,
      subscribersRows,
      selectedSubscribers,
      selectAllSubscribers,
      subscribersSortBy,
      subscribersSortDesc,
      subscribersTitle,
      // subscribersHeadersShifted,
      showHeader,
      canBulkAction,
      subscribersBulkActions,
      subscribersBulkActionsText,
      toggleShowSubscriberBulkActions,
      toggleSelectSubscriber,
      setSelectAllSubscribers,
      sortSubscribersColumn,
      setSubscribersColumnSortBy,
      showSubscriberStats,
      addSubscribersToList,
      updateSubscriber,
      initSubscribers,
    }
  },
})
</script>
